var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var ReUpField = require('./ReUpField');
var PlatformConstants = require('./constants/PlatformConstants');
var NumericalInput = require('./NumericalInput');
var MKSegmentControl = require('./MKSegmentControl.js');
var Icon = require('./wrappers/ReUpIcon');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  StyleSheet,
} = ReactNative;

var GiftCardOptions = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      extras : {},
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      campaigns : [],
      useCreditCampaign : null,
      referCampaign : null,
      checkInCampaign : null,
      transferLoyaltyCampaign : null,
      transferLabels: [],
    }
  },

  componentDidMount : function()
  {
    var thisThing = this;
    this.props.appManager.getCurrentUser(function(currentUser)
    {
      thisThing._PIN = currentUser.ScannerPIN;
    })
  },

  didUpdate : function(data)
  {
    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    NetworkManager.getGCInfoByUserIDVendor(appManager, thisThing.props.extras.UserID, thisThing.props.extras.hash, function(data)
    {
      for( var key in data )
      {
        thisThing.props.extras[key] = data[key];
      }
      if( typeof thisThing.props.extras.PhoneNumber !== 'undefined' ) thisThing.props.extras.phoneNumber = thisThing.props.extras.PhoneNumber;
      thisThing.forceUpdate();
    }, function(data)
    {
    }, function(data)
    {
    })
    if( typeof data.Campaigns !== 'undefined' )
    {
      var useCreditCampaign = null;
      var referCampaign = null;
      var checkInCampaign = null;
      var transferLoyaltyCampaign = null;
      for( var i = 0; i < data.Campaigns.length; i++ )
      {
        var campaign = data.Campaigns[i];
        if( campaign.Type == "UseCredit" ) useCreditCampaign = JSON.parse(campaign.CampaignBlob);
        if( campaign.Type == "Referral" ) referCampaign = JSON.parse(campaign.CampaignBlob);
        if( campaign.Type == "Checkin" || campaign.Type == "CheckIn" ) checkInCampaign = JSON.parse(campaign.CampaignBlob);
        if( campaign.Type == "TransferLoyalty" ) transferLoyaltyCampaign = JSON.parse(campaign.CampaignBlob);
      }
      // var useCreditCampaign =  {Type: "UseCredit", DollarsPerPoint: 1};
      // var referCampaign =  {Type: "Referral", ReferrerPoints: 10, RefereePoints: 10};
      // var checkInCampaign =  {Type: "Checkin", DollarsPerPoint: 2, FixedPoints: 0};
      // var transferLoyaltyCampaign =  {Type: "TransferLoyalty", Identifier: ["p", "e"]};

      this.setState({
        campaigns:data.Campaigns,
        useCreditCampaign:useCreditCampaign,
        referCampaign:referCampaign,
        checkInCampaign:checkInCampaign,
        transferLoyaltyCampaign:transferLoyaltyCampaign
      });
    }
  },

  _isLoyaltyingEmail:true,
  _loyaltyTransferEmail:"",
  _loyaltyTransferPhone1:"",
  _loyaltyTransferPhone2:"",
  _loyaltyTransferPhone3:"",
  _loyaltyLabels: [],
  _loyaltyTransferTabSelected: [],
  _loyaltyTransferPhoneIndex: 0,
  _loyaltyTransferEmailIndex: 0,
  _loyaltyTransferExternalIDIndex: 0,
  showLoyaltyTransfer: function()
  {
    var locMan = this.props.appManager.getLocalizationManager();
    this._loyaltyTransferEmail = "";
    this._loyaltyTransferPhone = "";
    var modes = this.state.transferLoyaltyCampaign.Modes;
    this._loyaltyLabels = [];
    this._loyaltyTransferTabSelected = [];
    var showSwitch = modes.length > 1;
    if( modes.length <= 0 ) return;
    
    for( var i = 0; i < modes.length; i++ )
    {
      if( modes[i] == "p" )
      {
        this._loyaltyLabels.push(locMan.localizedStringForKey("PHONE_OPTION"));
        this._loyaltyTransferTabSelected.push(()=>this.showLoyaltyTransferPhone(showSwitch));
        this._loyaltyTransferPhoneIndex = i;
      }
      else if( modes[i] == "e" )
      {
        this._loyaltyLabels.push(locMan.localizedStringForKey("EMAIL_OPTION"));
        this._loyaltyTransferTabSelected.push(()=>this.showLoyaltyTransferEmail(showSwitch));
        this._loyaltyTransferEmailIndex = i;
      }
      else if( modes[i] == "i" )
      {
        this._loyaltyLabels.push(locMan.localizedStringForKey("CARDID_OPTION", "Card ID"));
        this._loyaltyTransferTabSelected.push(()=>this.showLoyaltyTransferExternalID(showSwitch));
        this._loyaltyTransferExternalIDIndex = i;
      }
    }
    if( modes[0] == "p" )
    {
      this.showLoyaltyTransferPhone(showSwitch);
    }
    else if( modes[0] == "e" )
    {
      this.showLoyaltyTransferEmail(showSwitch);
    }
    else if( modes[0] == "i" )
    {
      this.showLoyaltyTransferExternalID(showSwitch);
    }
  },

  showLoyaltyTransferEmail : function(showSwitch)
  {
    var showSwitch = typeof showSwitch === 'undefined' || showSwitch;
    this._isLoyaltyingEmail = true;
    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locMan = this.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");
    var emailLabel = locMan.localizedStringForKey("EMAIL_OPTION");
    var phoneLabel = locMan.localizedStringForKey("PHONE_OPTION");
    var okButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
    var oneTimeOnly = locMan.localizedStringForKey("LOYALTY_TRANSFER_STATEMENT");

    var userID = this.props.extras.UserID;

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:10,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View>
          <View style={{paddingBottom:8}}>
            <ReUpText appManager={appManager} style={{textAlign:'center'}}>
              {oneTimeOnly}
            </ReUpText>
          </View>
          {
            showSwitch ?
              <MKSegmentControl
                style={styles.referTypeContainer}
                choiceTitles={this._loyaltyLabels}
                selectedIndex={thisThing._loyaltyTransferEmailIndex}
                didSelectIndex={function(index){thisThing._loyaltyTransferTabSelected[index]()}}
                activeBackgroundColor={primaryButtonColor}
                activeShadowColor={primaryButtonBorderColor}
                activeTextColor={primaryButtonTitleColor}
                inactiveBackgroundColor={secondaryButtonColor}
                inactiveTextColor={secondaryButtonTitleColor}/> : null
          }
          <View style={styles.alertInnerContainer}>
            <ReUpField
              ref={(a)=>{thisThing._loyaltyTransferEmailField = a; if( a != null ) a.focus();}}
              key="email"
              appManager={appManager}
              keyboardType={"email-address"}
              onChangeText={(text) => {thisThing._loyaltyTransferEmail = text}}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              textInputStyle={{color: generalTitleColor}}
              placeholder={emailLabel}
              floatingLabelEnabled={true}
              floatingLabelAniDuration={.1}
              returnKeyType={"done"}
              onSubmitEditing={thisThing.submitEmail}
              style={{flex:1}}/>
          </View>
          <ReUpButton style={[styles.button,{marginTop:30}]}
            appManager={appManager}
            text={okButton}
            onPress={thisThing.submitEmail}
          />
        </View>
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
    });
  },

  submitEmail : function()
  {
    var thisThing = this;
    var appActions = this.props.appActions;
    var extras = this.props.extras;
    var appManager = this.props.appManager;
    var userID = this.props.extras.UserID;

    thisThing._loyaltyTransferEmailField.setIsInError(!appManager.isValidEmail(thisThing._loyaltyTransferEmail))
    if( appManager.isValidEmail(thisThing._loyaltyTransferEmail) )
    {
      thisThing._loyaltyTransferEmailField.setIsInError(false);
      appActions.hideAlert();
      appActions.setSpinnerShown(true);
      NetworkManager.vendorTransferLoyaltyCampaign(appManager, userID, thisThing._loyaltyTransferEmail, "", "", thisThing.props.extras.hash, function(data)
      {
        appActions.setSpinnerShown(false);
        var extras = data;
        extras.success = true;
        extras.isTransfer = true;
        extras.scanner = thisThing.props.extras.scanner;;
        appActions.requestFeatureName("TransactionResult", extras);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        thisThing.props.appActions.showLocalizedAlert("TRANSFER_LOYALTY_FAIL_ALERT_TITLE", "TRANSFER_LOYALTY_FAIL_ALERT_BODY",["OK_ALERT_BUTTON"],[thisThing.showLoyaltyTransfer],thisThing.props.appActions.hideAlert);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        thisThing.props.appAction.showNetworkErrorAlert();
      })
    }
    else
    {
      thisThing._loyaltyTransferEmailField.setIsInError(true);
    }
  },

  _loyaltyTransferExternalID: "",
  showLoyaltyTransferExternalID : function(showSwitch)
  {
    var showSwitch = typeof showSwitch === 'undefined' || showSwitch;
    this._isLoyaltyingExternalID = true;
    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locMan = this.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");
    var okButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
    var oneTimeOnly = locMan.localizedStringForKey("LOYALTY_TRANSFER_STATEMENT");
    var externalIDLabel = locMan.localizedStringForKey("CARDID_OPTION", "Card ID");

    var userID = this.props.extras.UserID;

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:10,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View>
          <View style={{paddingBottom:8}}>
            <ReUpText appManager={appManager} style={{textAlign:'center'}}>
              {oneTimeOnly}
            </ReUpText>
          </View>
          {
            showSwitch ?
              <MKSegmentControl
                style={styles.referTypeContainer}
                choiceTitles={this._loyaltyLabels}
                selectedIndex={thisThing._loyaltyTransferExternalIDIndex}
                didSelectIndex={function(index){thisThing._loyaltyTransferTabSelected[index]()}}
                activeBackgroundColor={primaryButtonColor}
                activeShadowColor={primaryButtonBorderColor}
                activeTextColor={primaryButtonTitleColor}
                inactiveBackgroundColor={secondaryButtonColor}
                inactiveTextColor={secondaryButtonTitleColor}/> : null
          }
          <View style={styles.alertInnerContainer}>
            <ReUpField
              ref={(a)=>{thisThing._loyaltyTransferExternalIDField = a; if( a != null ) a.focus();}}
              key="externalID"
              appManager={appManager}
              autoCapitalize={"none"}
              onChangeText={(text) => {thisThing._loyaltyTransferExternalID = text}}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              textInputStyle={{color: generalTitleColor}}
              placeholder={externalIDLabel}
              floatingLabelEnabled={true}
              floatingLabelAniDuration={.1}
              returnKeyType={"done"}
              onSubmitEditing={thisThing.submitExternalID}
              style={{flex:1}}/>
          </View>
          <ReUpButton style={[styles.button,{marginTop:30}]}
            appManager={appManager}
            text={okButton}
            onPress={thisThing.submitExternalID}
          />
        </View>
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
    });
  },

  submitExternalID : function()
  {
    var thisThing = this;
    var appActions = this.props.appActions;
    var extras = this.props.extras;
    var appManager = this.props.appManager;
    var userID = this.props.extras.UserID;

    var isValidExternalID = thisThing._loyaltyTransferExternalID.length > 0;
    thisThing._loyaltyTransferExternalIDField.setIsInError(!isValidExternalID);
    if( isValidExternalID)
    {
      thisThing._loyaltyTransferExternalIDField.setIsInError(false);
      appActions.hideAlert();
      appActions.setSpinnerShown(true);
      NetworkManager.vendorTransferLoyaltyCampaign(appManager, userID, "", "", thisThing._loyaltyTransferExternalID, thisThing.props.extras.hash, function(data)
      {
        appActions.setSpinnerShown(false);
        var extras = data;
        extras.success = true;
        extras.isTransfer = true;
        extras.scanner = thisThing.props.extras.scanner;;
        appActions.requestFeatureName("TransactionResult", extras);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        thisThing.props.appActions.showLocalizedAlert("TRANSFER_LOYALTY_FAIL_ALERT_TITLE", "TRANSFER_LOYALTY_FAIL_ALERT_BODY",["OK_ALERT_BUTTON"],[thisThing.showLoyaltyTransfer],thisThing.props.appActions.hideAlert);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        thisThing.props.appAction.showNetworkErrorAlert();
      })
    }
    else
    {
      thisThing._loyaltyTransferExternalIDField.setIsInError(true);
    }
  },

  _PIN:"",
  checkPinError : function(value)
  {
    if( value.length < this._PIN.length ) return false;

    return value != this._PIN;
  },

  checkPinSuccess : function(value)
  {
    return value == this._PIN;
  },

  showPin : function(success)
  {
    if( this._PIN.length <= 0 )
    {
      success();
      return;
    }

    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var enterPinStr = locManager.localizedStringForKey("ENTER_PIN_STATEMENT");
    var customAlert = <View style={{flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
      <View style={{margin:5}}>
        <ReUpText isTitle={true} fontSize={32}>{enterPinStr}</ReUpText>
      </View>
      <NumericalInput style={{height:400, alignSelf:'stretch'}} maxLength={this._PIN.length} didSucceed={function()
        {
          appActions.hideAlert();
          success()
        }} checkPinSuccess={this.checkPinSuccess} checkPinError={this.checkPinError} appManager={this.props.appManager} isDisplayingPin={true} />
    </View>
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
    });
  },

  showLoyaltyTransferPhone : function(showSwitch)
  {
    var showSwitch = typeof showSwitch === 'undefined' || showSwitch;
    this._isLoyaltyingEmail = false;
    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locMan = this.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");
    var emailLabel = locMan.localizedStringForKey("EMAIL_OPTION");
    var phoneLabel = locMan.localizedStringForKey("PHONE_OPTION");
    var okButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
    var oneTimeOnly = locMan.localizedStringForKey("LOYALTY_TRANSFER_STATEMENT");

    var phoneSeparators = ["(",") "," - "]

    var userID = this.props.extras.UserID;

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:10,marginLeft:10,marginRight:10}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View>
          <View style={{paddingBottom:8}}>
            <ReUpText appManager={appManager} style={{textAlign:'center'}}>
              {oneTimeOnly}
            </ReUpText>
          </View>
          {
            showSwitch ?
              <MKSegmentControl
                style={styles.referTypeContainer}
                choiceTitles={this._loyaltyLabels}
                didSelectIndex={function(index){thisThing._loyaltyTransferTabSelected[index]()}}
                selectedIndex={thisThing._loyaltyTransferPhoneIndex}
                activeBackgroundColor={primaryButtonColor}
                activeShadowColor={primaryButtonBorderColor}
                activeTextColor={primaryButtonTitleColor}
                inactiveBackgroundColor={secondaryButtonColor}
                inactiveTextColor={secondaryButtonTitleColor}/> : null
          }
          <View style={[styles.alertInnerContainer, {paddingRight:8, alignItems:'center', height:70, justifyContent:'center'}]}>
            <ReUpText appManager={appManager} style={{marginTop:26, padding:4}}>{phoneSeparators[0]}</ReUpText>
            <ReUpField
              appManager={appManager}
              ref={(a)=>{thisThing._phone1=a; if( a != null ) a.focus();}}
              key="phone1"
              keyboardType={"phone-pad"}
              onChangeText={(text) => {thisThing._loyaltyTransferPhone1 = text; if( text.length >= 3 ) thisThing._phone2.focus()}}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              textInputStyle={{color: generalTitleColor}}
              placeholder={"###"}
              maxLength={3}
              style={[styles.textField, {width:45}]}/>
            <ReUpText appManager={appManager} style={{flex:-1, marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[1]}</ReUpText>
            <ReUpField
              appManager={appManager}
              ref={(a)=>{thisThing._phone2=a}}
              key="phone2"
              keyboardType={"phone-pad"}
              onChangeText={(text) => {thisThing._loyaltyTransferPhone2 = text; if( text.length >= 3 ) thisThing._phone3.focus()}}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              textInputStyle={{color: generalTitleColor}}
              placeholder={"###"}
              maxLength={3}
              style={[styles.textField, {width:45}]}/>
            <ReUpText appManager={appManager} style={{flex:-1, marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[2]}</ReUpText>
            <ReUpField
              appManager={appManager}
              ref={(a)=>{thisThing._phone3=a}}
              key="phone3"
              keyboardType={"phone-pad"}
              onChangeText={(text) => {thisThing._loyaltyTransferPhone3 = text}}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              textInputStyle={{color: generalTitleColor}}
              placeholder={"####"}
              maxLength={4}
              onSubmitEditing={thisThing.submitPhone}
              returnKeyType={"done"}
              style={[styles.textField, {width:65}]}/>
          </View>
          <ReUpButton style={[styles.button,{marginTop:30}]}
            appManager={appManager}
            text={okButton}
            onPress={thisThing.submitPhone}
          />
        </View>
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert, function()
    {
    });
  },

  resendVerification : function()
  {
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var userID = this.props.extras.userID;
    var hash = this.props.extras.hash;
    appActions.setSpinnerShown(true);
    NetworkManager.resendVerification(this.props.appManager, userID, hash, ()=>
    {
      appActions.setSpinnerShown(false); 
      appActions.showLocalizedAlert("SUCCESS_VERIFICATION_SENT_ALERT_TITLE", "SUCCESS_VERIFICATION_SENT_ALERT_BODY",["OK_ALERT_BUTTON"],[appActions.hideAlert],appActions.hideAlert);
    }, ()=>
    {
      appActions.setSpinnerShown(false);
      appActions.showLocalizedAlert("ERROR_VERIFICATION_SENT_ALERT_TITLE", "ERROR_VERIFICATION_SENT_ALERT_BODY",["OK_ALERT_BUTTON"],[appActions.hideAlert],appActions.hideAlert);
    }, ()=>
    {
      appActions.setSpinnerShown(false);
      appActions.showLocalizedAlert("ERROR_VERIFICATION_SENT_ALERT_TITLE", "ERROR_VERIFICATION_SENT_ALERT_BODY",["OK_ALERT_BUTTON"],[appActions.hideAlert],appActions.hideAlert);    })
  },

  submitPhone : function()
  {
    var thisThing = this;
    var extras = this.props.extras;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var userID = this.props.extras.UserID;

    thisThing._phone1.setIsInError(thisThing._loyaltyTransferPhone1.length != 3);
    thisThing._phone2.setIsInError(thisThing._loyaltyTransferPhone2.length != 3);
    thisThing._phone3.setIsInError(thisThing._loyaltyTransferPhone3.length != 4);
    thisThing._loyaltyTransferPhone = thisThing._loyaltyTransferPhone1 + thisThing._loyaltyTransferPhone2 + thisThing._loyaltyTransferPhone3;

    if( thisThing._loyaltyTransferPhone1.length == 3 && thisThing._loyaltyTransferPhone2.length == 3 && thisThing._loyaltyTransferPhone3.length == 4 )
    {
      appActions.hideAlert();
      appActions.setSpinnerShown(true);
      NetworkManager.vendorTransferLoyaltyCampaign(appManager, userID, "", thisThing._loyaltyTransferPhone, "", thisThing.props.extras.hash, function(data)
      {
        appActions.setSpinnerShown(false);
        var extras = data;
        extras.success = true;
        extras.isTransfer = true;
        extras.scanner = thisThing.props.extras.scanner;;
        appActions.requestFeatureName("TransactionResult", extras);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        thisThing.props.appActions.showLocalizedAlert("TRANSFER_LOYALTY_FAIL_ALERT_TITLE", "TRANSFER_LOYALTY_FAIL_ALERT_BODY",["OK_ALERT_BUTTON"],[thisThing.showLoyaltyTransfer],thisThing.props.appActions.hideAlert);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        thisThing.props.appAction.showNetworkErrorAlert();
      })
    }
  },

  render: function()
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var feedFeatureData = appManager.getFeatureForName("DomainLogin");
    var thisThing = this;
    var appActions = this.props.appActions;
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

    var bgImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/" + feedFeatureData.data.bgImage);

    var userID = this.props.extras.UserID
    var phoneNumber = typeof this.props.extras.phoneNumber !== 'undefined' ? this.props.extras.phoneNumber : null
    var dollars = appManager.getLocalizationManager().localizedDollars(this.props.extras.Credit)
    var points = appManager.getLocalizationManager().localizedPoints(this.props.extras.Points)

    var localizedPhoneNumber = locManager.localizedPhone(phoneNumber);
    var phoneNumberStr = locManager.localizedStringForKeyAndParams("PHONE_NUMBER_LABEL_WITH_NUMBER", [localizedPhoneNumber], "Phone#: %0%");
    var resendVerificationLocalized = locManager.localizedStringForKey("RESEND_VERIFICATION_BUTTON", "Resend Verification");
    var sendPortalLinkLocalized = locManager.localizedStringForKey("SEND_PORTAL_LINK_BUTTON", "Send Portal Link");
    var resendAppDownloadLinkLocalized = locManager.localizedStringForKey("RESEND_APP_DOWNLOAD_LINK_BUTTON", "Resend App Download Link");
    var accountNotVerifiedCapsLocalized = locManager.localizedStringForKey("ACCOUNT_NOT_VERIFIED_CAPS_STATEMENT", "ACCOUNT NOT VERIFIED");
    var addCreditExtras = {addingCredit:true};
    for( var key in this.props.extras )
    {
      addCreditExtras[key] = this.props.extras[key]
    }

    var hasTransferredLoyalty = typeof this.props.extras.HasTransferredLoyalty === 'undefined' ? false : this.props.extras.HasTransferredLoyalty == 1;

    var shouldShowResendVerify = typeof this.props.extras !== 'undefined' && this.props.extras.shouldShowResendVerify;

    var user = appManager.currentUser();
    var sendPortalLinkButtonText = ((typeof this.props.extras.Verified !== 'undefined' && this.props.extras.Verified == 0) && appManager.currentUser()["RequireVerificationForRewards"] == 1) ? resendVerificationLocalized : sendPortalLinkLocalized;
    if( user != null && typeof user.ReUpPackage !== 'undefined' && user.ReUpPackage.length > 0 )
    {
      var reUpPackage = JSON.parse(user.ReUpPackage);
      if( typeof reUpPackage.type !== 'undefined' && reUpPackage.type == 'pro' ) sendPortalLinkButtonText = resendAppDownloadLinkLocalized;
    }

    return (
      <View style={[styles.container, {flexDirection:'column', backgroundColor:generalColor}]}>
        <ReUpScrollView responder={this}>
          <View style={{flexDirection:'column', flex:1, height:this.state.layout.height, width:this.state.layout.width}}>
            <View style={{flex:1}} />
            <View style={{flexDirection:'column', alignItems:'center', justifyContent:'center', margin:10, padding:10, borderRadius:10, backgroundColor:'white', width:-1}}>
              { false ? <ReUpText style={{color:generalTitleColor}}>{"UserID: "+userID}</ReUpText> : null }
              { phoneNumber == null ? null : <ReUpText style={{color:generalTitleColor}}>{phoneNumberStr}</ReUpText>}
              { typeof this.props.extras.Verified !== 'undefined' && this.props.extras.Verified == 0 ? <ReUpText style={{color:'red'}}>{accountNotVerifiedCapsLocalized}</ReUpText> : null}
              <ReUpText isTitle={true} style={{color:generalTitleColor}}>{dollars}</ReUpText>
              <ReUpText isTitle={true} style={{color:generalTitleColor}}>{points}</ReUpText>
            </View>
            {
              typeof this.props.extras.onlyPoints === 'undefined' || !this.props.extras.onlyPoints ?
                <ReUpButton style={[styles.button,{margin:10}]}
                  appManager={appManager}
                  text={locManager.localizedStringForKey("ADD_CREDIT_BUTTON")}
                  onPress={() =>
                  {
                    var extras = addCreditExtras;
                    extras.disableAutoScannerLaunch = true;
                    thisThing.showPin(function()
                    {
                      appActions.requestFeatureName("CreditInput", extras);
                    })
                  }}
                  />
              : null
            }
            {
              typeof this.props.extras.onlyPoints === 'undefined' || !this.props.extras.onlyPoints ?
                <ReUpButton style={[styles.button,{margin:10}]}
                  appManager={appManager}
                  text={locManager.localizedStringForKey("USE_CREDIT_BUTTON")}
                  onPress={() =>
                  {
                    var extras = thisThing.props.extras;
                    extras.disableAutoScannerLaunch = true;
                    appActions.requestFeatureName("CreditInput", extras);
                  }}
                  />
              : null
            }
            <ReUpButton style={[styles.button,{margin:10, opacity:typeof this.props.extras.Verified !== 'undefined' && this.props.extras.Verified == 0  && appManager.currentUser()["RequireVerificationForRewards"] == 1 ? .4 : 1}]}
              appManager={appManager}
              text={locManager.localizedStringForKey("USE_REWARD_BUTTON")}
              onPress={() =>
              {
                if( typeof thisThing.props.extras.Verified !== 'undefined' && thisThing.props.extras.Verified == 0 && appManager.currentUser()["RequireVerificationForRewards"] == 1 )
                {
                    appActions.showLocalizedAlert("ACCOUNT_NOT_VERIFIED_ALERT_TITLE", "ACCOUNT_NOT_VERIFIED_ALERT_BODY",["NO_ALERT_BUTTON", "OK_ALERT_BUTTON"],[appActions.hideAlert, ()=>
                    {
                    thisThing.resendVerification();
                    appActions.hideAlert();
                  }],appActions.hideAlert);
                  return;
                }

                var extras = thisThing.props.extras;
                extras.disableAutoScannerLaunch = true;
                appActions.requestFeatureName("GiftCardUseReward", extras);
              }}
              />

            <ReUpButton style={[styles.button,{margin:10}]}
              appManager={appManager}
              text={locManager.localizedStringForKey("ASSIGN_POINTS_BUTTON")}
              onPress={() =>
              {
                var extras = thisThing.props.extras;
                extras.disableAutoScannerLaunch = true;
                thisThing.showPin(function()
                {
                  appActions.requestFeatureName("CheckInInput", extras);
                })
              }}
              />

            {
              shouldShowResendVerify ?
                <ReUpButton style={[styles.button,{margin:10}]}
                  appManager={appManager}
                  text={sendPortalLinkButtonText}
                  onPress={() =>
                  {
                    thisThing.resendVerification();
                  }}
                  />
              : null
            }

            {
              hasTransferredLoyalty ? null :
              <ReUpButton style={[styles.button,{margin:10}]}
                appManager={appManager}
                text={locManager.localizedStringForKey("TRANSFER_LOYALTY_BUTTON")}
                onPress={() =>
                {
                  var extras = {};
                  extras.disableAutoScannerLaunch = true;
                  thisThing.showLoyaltyTransfer(extras)
                }}
                />
            }

            <ReUpButton isSecondary={true} style={[styles.button,{margin:10}]}
              appManager={appManager}
              text={locManager.localizedStringForKey("CANCEL_BUTTON")}
              onPress={() =>
              {
                thisThing.props.appActions.requestPop();
                if( typeof thisThing.props.extras.scanner !== 'undefined' )
                {
                  setTimeout(function()
                  {
                    thisThing.props.extras.scanner.scan();
                  },300)
                }
              }}
              />
            <View style={{flex:1}} />

          </View>
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
    backgroundColor:'white'
  },
  actionBarSpacer: {
    height:0,//Globals.ACTION_BAR_HEIGHT,
  },
  image: {
    position: 'absolute',
  },
  textField: {
  },
  alertInnerContainer: {
    paddingTop:4,
    paddingLeft:10,
    paddingRight:10,
    alignItems:'center',
    justifyContent:'center',
    flexDirection:'row',
  },
});


GiftCardOptions.dataDependencies = ["Rewards", "Campaigns"]

module.exports = GiftCardOptions;
